import {SpinnerModule} from '../../spinner/spinner.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { PipesModule } from '../../../core/pipes/pipes.module';
import { NativeVideoPreviewComponent } from './native-video-preview.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    SkeletonModule,
    SpinnerModule,
  ],
  declarations: [NativeVideoPreviewComponent],
  exports: [NativeVideoPreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NativeVideoPreviewModule {}
